import type { AnyGameDefinition, OptionValue, Validation } from './types.ts';

/**
 * Checks untrusted settings against a game's declared `optionSpecs` (ADR-0011):
 * only declared keys, and only their listed choices.
 */
export function validateOptions(game: AnyGameDefinition, options: Readonly<Record<string, unknown>>): Validation {
  const specs = game.optionSpecs ?? [];
  for (const [key, value] of Object.entries(options)) {
    const spec = specs.find((s) => s.key === key);
    if (!spec) return { ok: false, reason: `${game.name} has no setting "${key}"` };
    if (!spec.choices.some((c) => c.value === value)) return { ok: false, reason: `${JSON.stringify(value)} is not a choice for ${spec.label}` };
  }
  return { ok: true };
}

/** Current value of every declared setting: overrides where given, else the game default. */
export function resolveSettings(game: AnyGameDefinition, overrides: Readonly<Record<string, OptionValue>> = {}): Record<string, OptionValue> {
  const defaults = game.defaultOptions as Record<string, OptionValue>;
  return Object.fromEntries((game.optionSpecs ?? []).map((s) => [s.key, s.key in overrides ? overrides[s.key]! : defaults[s.key] ?? null]));
}
